var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"px-2":"","py-2":"","mt-1":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"px-2":""}},[_c('a-form-view',{attrs:{"value":_vm.data,"model":_vm.getFormModel(['department', 'name', 'date_start', 'date_end']),"config":{ dense: true }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }